import settings from "./settings";

//Kép neve, és a hozzá tartozó Alt property
const alts = {
    "csango10-elado-lakasok.webp" : "újépítésű lakások budapest",
    "csango10-ujepitesu-lakasok.webp" : "13.kerületi eladó lakások",

    "default" : settings.imageAlt,
}

export default alts;